import { render, staticRenderFns } from "./insights-card.vue?vue&type=template&id=15023439&scoped=true&"
import script from "./insights-card.vue?vue&type=script&lang=ts&"
export * from "./insights-card.vue?vue&type=script&lang=ts&"
import style0 from "./insights-card.vue?vue&type=style&index=0&id=15023439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15023439",
  null
  
)

export default component.exports